// ひとまず英語にした sakao
export const errorMsg = {
  SYSTEM_ERROR: 'system_error',
  AUTH_ERROR: 'error_authentication_failed',
  SESSION_ERROR: 'error_timeout_logout',
  SESSION_ERROR_TAB_CLOSE: 'error_timeout_tab_close',
  EXPIRES_ERROR: 'label_QR_code_exprired',
  PASSWORD_UNMATCH_ERROR: 'error_new_password_not_match',
  URL_ERROR: 'label_invalid_URL',
  UNSUPPORTED_FILE_ERROR: 'error_unsupported_file',
  FILE_SIZE_ERROR: 'label_file_size_500_exceeds',
  IMPORT_FILE_SIZE_ERROR: 'label_file_size_800_exceeds',
  AUTH_LIMIT_ERROR: 'error_login_attempts_exceeded',
  QR_AUTH_LIMIT_ERROR: 'error_login_attempts_exceeded',
}

// ひとまず英語にした sakao
export const confirmMsg = {
  EMAIL_SENDED: 'label_confirmation_email',
  PASSWORD_UPDATEED: 'label_email_update',
}

// ひとまず英語にした sakao
export const okMsg = {
  NO_EXPORT_DATA: 'label_export_data_no_registered',
}
